import { render, staticRenderFns } from "./ExtendedProfileQuestionRow.vue?vue&type=template&id=70cc713a&"
import script from "./ExtendedProfileQuestionRow.vue?vue&type=script&lang=js&"
export * from "./ExtendedProfileQuestionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports